import React, { useEffect, useState } from 'react';
import OneProduct from '../../Store/oneProduct';
import { doc, getDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { db } from '../../../firebaseConfig';
import EmptyPage from '../../Commons/EmptyPage';
import { Container, Typography, Box } from '@mui/material';

const Cart = () => {
  const [products, setProducts] = useState([]);
  const { userId } = useParams();
  const userData = JSON.parse(localStorage.getItem('user') || null);

  useEffect(() => {
    const fetchProducts = async () => {
      const storeRef = doc(db, 'cart', userId);
      const data = await getDoc(storeRef);
      if (data.exists()) {
        const productsData = data.data().cart;
        setProducts(productsData);
      } else {
        setProducts([]); // If no data exists, reset products to an empty array
      }
    };
    fetchProducts();
  }, [userId]);

  if (products.length === 0) {
    return <EmptyPage message="Your cart is empty" />;
  }

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Your Shopping Cart
      </Typography>
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          You have {products.length} {products.length === 1 ? 'item' : 'items'} in your cart.
        </Typography>
      </Box>
      <Box 
        sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 4, 
          justifyContent: 'center' 
        }}
      >
        {products.map((product) => (
          <Box
            key={product._id}
            sx={{
              width: {
                xs: '100%',  // Full width on small screens
                sm: 'calc(50% - 16px)', // Half width with gap on medium screens
                md: 'calc(33.33% - 16px)', // Third width with gap on large screens
              },
              padding: 2,
              boxShadow: 3,
              borderRadius: 2,
              backgroundColor: 'white',
            }}
          >
            <OneProduct product={product} />
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default Cart;
